/* RESPONSIBLE TEAM: team-conversational-knowledge */
import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
import EmbercomBaseSerializer from 'embercom/serializers/base/embercom-base-serializer';

export default EmbercomBaseSerializer.extend(EmbeddedRecordsMixin, {
  attrs: {
    sourceSection: { embedded: 'always' },
    targetSection: { embedded: 'always' },
    contentReviewRequest: { embedded: 'always' },
  },
});
